import type { BaseQueryFn } from '@reduxjs/toolkit/query';
import { envConfig } from '@src/utils/envConfig';
import { Delete, FetchError, Get, Patch, Post, Put } from '@talos/kyoko';

export interface AvaApiRESTBaseQueryArgs {
  url: string;
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  body?: any;
  headers?: HeadersInit;
}

/**
 * RTK-Q base query for interacting with the Ava API.
 */
export const avaApiRESTBaseQuery: BaseQueryFn<
  AvaApiRESTBaseQueryArgs, // args type into the query
  any, // return type. For ava api, we dont have anything like DataResponse -- it can be anything lol
  FetchError | Error // these types are what our performRequest (which is what we're calling under the hood) seem to throw
> = async ({ url, method, body, headers }, api, _extraOptions) => {
  const avaApiEndpoint = `${envConfig.VITE_AVA_API_ENDPOINT}`;
  // for now we just support headers as options
  const options = headers ? { headers } : undefined;

  try {
    const requestPromise =
      method === 'GET'
        ? Get(avaApiEndpoint, url, options)
        : method === 'POST'
          ? Post(avaApiEndpoint, url, body, options)
          : method === 'PUT'
            ? Put(avaApiEndpoint, url, body, options)
            : method === 'PATCH'
              ? Patch(avaApiEndpoint, url, body, options)
              : Delete(avaApiEndpoint, url, body, options);

    const result = await requestPromise;
    return { data: result };
  } catch (e) {
    if (e instanceof FetchError || e instanceof Error) {
      return { error: e };
    } else {
      // Otherwise we're dealing with some weird error type and we don't know what it is... this is a catch-all :/
      return { error: new Error('Failure when making request') };
    }
  }
};
